import React from "react";
import { Award, Lock, Clock8, Heart } from "lucide-react";
import { SectionTitle } from "./Helpers";

const BADGES = [
  { id: "lignee", Ico: Award, t: "Lignée authentique", d: "Héritier direct des grands marabouts d'Afrique de l'Ouest, initié dès l'enfance aux savoirs sacrés." },
  { id: "experience", Ico: Clock8, t: "35 ans d'expérience", d: "Trois décennies passées à écouter, comprendre et transformer des milliers de vies." },
  { id: "discretion", Ico: Lock, t: "Discrétion absolue", d: "Aucun détail ne sort du cabinet. Votre histoire est protégée comme un secret sacré." },
  { id: "honnetete", Ico: Heart, t: "Honnêteté rare", d: "Il ne promet jamais l'impossible. Vous savez dès le premier appel ce qui peut être accompli." }
];

export default function TrustBadgesSection() {
  return (
    <section className="py-16 bg-charcoal">
      <div className="container-narrow">
        <SectionTitle
          over="Pourquoi Maître Diamma"
          title="La confiance, transmise depuis trois générations"
          sub="Ce qui distingue un vrai maître d'un simple praticien : la lignée, la parole, et les résultats."
        />
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-10">
          {BADGES.map(({ id, Ico, t, d }) => (
            <div key={id} className="trust-badge p-6">
              <div className="w-12 h-12 rounded-full gold-border flex items-center justify-center mb-4">
                <Ico className="w-6 h-6 text-gold" />
              </div>
              <h3 className="font-display text-lg text-gold mb-2">{t}</h3>
              <p className="text-sm text-gold-soft/95 leading-relaxed">{d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
